import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_cozy_textures: FaireThemeEntity = {
  token: "discovery_theme_cozy-textures",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Cozy Textures & Textiles",
  description: "Soft fabrics and warm textiles for every season",
  bgColor: "#D6E0F0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
